import { graphql, useStaticQuery } from "gatsby";
import { Query } from "gatsbyGraphqlTypes";

export type KnowledgeItemWithPageContents = {
  type: "wissensbereich" | "wissensgruppe";
  id: number;
  pageContents: Array<{
    slug: string;
    locale: string;
    title?: string;
  }>;
};

export const useKnowledgeItems = (): KnowledgeItemWithPageContents[] => {
  const { strapi } = useStaticQuery<Query>(query);

  const wissensbereichMap = new Map<number, KnowledgeItemWithPageContents>();
  strapi.wissensbereichItems?.data?.forEach((item) => {
    if (!item?.attributes) return;

    const id = Number(item.attributes.WB_ID);
    const pageContent = item.attributes.targetPageContent?.data?.attributes;

    if (!pageContent) return;

    if (!wissensbereichMap.has(id)) {
      wissensbereichMap.set(id, {
        type: "wissensbereich",
        id,
        pageContents: [],
      });
    }

    wissensbereichMap.get(id)?.pageContents.push({
      slug: pageContent.slug || "",
      locale: pageContent.locale || "",
      title: pageContent.title || undefined,
    });
  });

  const wissengruppeMap = new Map<number, KnowledgeItemWithPageContents>();
  strapi.wissensgruppeItems?.data?.forEach((item) => {
    if (!item?.attributes) return;
    const id = Number(item.attributes.WG_ID);
    const pageContent = item.attributes.targetPageContent?.data?.attributes;

    if (!pageContent) return;

    if (!wissengruppeMap.has(id)) {
      wissengruppeMap.set(id, {
        type: "wissensgruppe",
        id,
        pageContents: [],
      });
    }

    wissengruppeMap.get(id)?.pageContents.push({
      slug: pageContent.slug || "",
      locale: pageContent.locale || "",
      title: pageContent.title || undefined,
    });
  });

  const allItems = [...Array.from(wissensbereichMap.values()), ...Array.from(wissengruppeMap.values())];

  return allItems;
};

const query = graphql`
  query useKnowledgeItems {
    strapi {
      wissensbereichItems(locale: "all", pagination: { limit: -1 }) {
        data {
          attributes {
            WB_ID
            locale
            status
            targetPageContent {
              data {
                attributes {
                  slug
                  locale
                }
              }
            }
          }
        }
      }
      wissensgruppeItems(locale: "all", pagination: { limit: -1 }) {
        data {
          attributes {
            WG_ID
            locale
            status
            targetPageContent {
              data {
                attributes {
                  slug
                  locale
                }
              }
            }
          }
        }
      }
    }
  }
`;
